export default __webpack_public_path__ + "static/media/No1.f82e3d07.jpg";